/**
 * UrbanGent: Variant-based Gallery Image Filter
 * Shows all images on initial page load.
 * Filters only after user actively clicks a color variant.
 *
 * 2026-05-31: Rename-tolerant gemacht. Der ausgewaehlte Variant-Name wird
 * durch dieselbe Keyword-Normalisierung geschickt wie der ALT-Text. Dadurch
 * brechen Cognac<->Braun-Renames den Filter nicht mehr (vgl. Bug 2026-05-16/28).
 * COLOR_KEYWORDS-Key bleibt 'Cognac'; 'braun'/'brown' sind als Keywords drin,
 * damit sowohl der Options-Wert 'Cognac' als auch 'Braun' darauf normalisieren.
 */
(function() {
  'use strict';

  var COLOR_KEYWORDS = {
    'Schwarz': ['schwarz', 'black'],
    'Cognac': ['cognac', 'braun', 'brown', 'suede']
  };

  var userHasInteracted = false;

  function getColorForAlt(alt) {
    if (!alt) return null;
    var lowerAlt = alt.toLowerCase();
    for (var color in COLOR_KEYWORDS) {
      var keywords = COLOR_KEYWORDS[color];
      for (var i = 0; i < keywords.length; i++) {
        if (lowerAlt.indexOf(keywords[i]) !== -1) return color;
      }
    }
    return null;
  }

  function filterGallery(selectedVariantName) {
    // Variant-Namen ueber dieselbe Keyword-Map normalisieren wie ALT-Texte.
    // 'Cognac' und 'Braun' -> beide auf den 'Cognac'-Key. Rename-sicher.
    var selectedColor = getColorForAlt(selectedVariantName) || selectedVariantName;

    var mediaItems = document.querySelectorAll('.product__media-item');
    var thumbnails = document.querySelectorAll('.thumbnail-list__item');

    mediaItems.forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var color = getColorForAlt(img.alt);
      if (!color) return;
      if (color === selectedColor) {
        item.style.display = '';
        item.classList.remove('ug-hidden-variant');
      } else {
        item.style.display = 'none';
        item.classList.add('ug-hidden-variant');
      }
    });

    thumbnails.forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var color = getColorForAlt(img.alt);
      if (!color) return;
      if (color === selectedColor) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });

    var firstVisible = document.querySelector('.product__media-item:not(.ug-hidden-variant)');
    if (firstVisible) {
      mediaItems.forEach(function(item) { item.classList.remove('is-active'); });
      firstVisible.classList.add('is-active');
      var slider = firstVisible.closest('.slider');
      if (slider && firstVisible.offsetLeft !== undefined) {
        slider.scrollTo({ left: firstVisible.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  function getSelectedVariantName() {
    var colorLabel = document.querySelector('.product-form__input .form__label');
    if (colorLabel) {
      var text = colorLabel.textContent.trim();
      var match = text.match(/:\s*(.+)/);
      if (match) return match[1].trim();
    }
    var activeSwatch = document.querySelector('input[name*="Farbe"]:checked, input[name*="Color"]:checked');
    if (activeSwatch) return activeSwatch.value;
    return null;
  }

  function onVariantChange() {
    userHasInteracted = true;
    setTimeout(function() {
      var color = getSelectedVariantName();
      if (color) filterGallery(color);
    }, 100);
  }

  function init() {
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"], select')) {
        onVariantChange();
      }
    });

    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('.product-form__input label, .product-form__input input');
      if (swatch) {
        onVariantChange();
      }
    });

    window.addEventListener('popstate', function() {
      if (userHasInteracted) {
        onVariantChange();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
